import styled from 'styled-components'

import {
  ModalContent,
  ModalInner,
} from '../components/auth-modal/auth-modal.styled'
import { PAGE_LAYOUT_OFFSET } from '../constants/layout'

export const AuthPageRoot = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - ${PAGE_LAYOUT_OFFSET}px);
  min-height: calc(100vh - ${PAGE_LAYOUT_OFFSET}px);
  max-height: calc(100vh - ${PAGE_LAYOUT_OFFSET}px);
  box-sizing: border-box;
  overflow: hidden;
`

export const AuthPageBackdrop = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
  border-top: 1px solid #313131ff;
`

export const AuthPageScrollLayer = styled.div`
  position: relative;
  z-index: 1;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 1em;
  -webkit-overflow-scrolling: touch;
`

export const AuthPageScrollCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding-top: 1em;

  &::after {
    content: '';
    display: block;
    flex-shrink: 0;
    width: 100%;
    height: 2rem;
  }
`

export const AuthPageContent = styled(ModalContent)`
  flex-shrink: 0;
  margin-bottom: 1.5em;
  margin-top: 5vh;

`

export const AuthPageInner = styled(ModalInner)`
  padding-top: 1em; 
  padding-bottom: 1.25em;
  box-sizing: border-box;
`
